import { useContext } from 'react';
import { StoreContext } from '@/providers/StoreProvider';

export function useStores() {
  return useContext(StoreContext);
}
